import { cloneElement, Children, Component } from 'react';

import cx from 'classnames';

import styles from '../../../styles/accordian.scss';

export class AccordionSection extends Component<any> {
  public onSelect = () => {
    // tell the parent Accordion component that this section was selected
    this.props._onSelect(this.props.id);
  };

  public enhanceSection = (child: any) => {
    const { _showRadio, id, _selected }: any = this.props;

    return cloneElement(child, {
      styles,
      onSelect: this.onSelect,
      _showRadio,
      id,
      _selected,
    });
  };

  public render() {
    const { _selected }: any = this.props;
    const children = Children.map(this.props.children, this.enhanceSection);
    return (
      <div
        className={cx(styles['accordion-section'], {
          [styles.selected]: _selected,
        })}
      >
        {children}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./components/ui/accordian/accordianSection.tsx